

export class AttendanceDetails implements IAttendanceDetails {
    entryDate!: Date;
    status!: string | undefined;

    constructor(data?: IAttendanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AttendanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAttendanceDetails {
    entryDate: Date;
    status: string | undefined;
}

